import { type FC } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import AddressForm from './AddressForm';
import { useQuery } from '@tanstack/react-query';
import { addressQueryKeyBoth, loadBothAddresses } from '@/api/registration';
import { useTenantApi } from '@/account/hook/useTenantApi';
import QueryContainer from '@/base/QueryContainer/QueryContainer';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { useGroupRegistrationQuery } from '@/registration/hook/useGroupRegistrationQuery';
import GroupHeader from '@/registration/component/Register/Layout/GroupHeader';

const Checkout: FC = () => {
  const { createTenantApiRequest, isLoading: isApiPreparing } = useTenantApi();
  const { eventId } = useRegisterRoute();
  const groupRegistrationQuery = useGroupRegistrationQuery(eventId);

  const bothAddressQuery = useQuery(
    [addressQueryKeyBoth],
    async () => await fetchBothAddresses(groupRegistrationQuery?.data?.id),
    {
      enabled: !isApiPreparing && !!groupRegistrationQuery?.data
    }
  );

  async function fetchBothAddresses(groupRegistrationId: number | undefined): Promise<any> {
    if (typeof groupRegistrationId === 'undefined') {
      return await Promise.reject(new Error('Invalid groupRegistrationId'));
    }

    const response = await loadBothAddresses(createTenantApiRequest)({ groupRegistrationId });
    return response.item;
  }

  return (
    <RegisterLayout header={<GroupHeader />}>
      <QueryContainer query={bothAddressQuery}>
        {(addresses) => <AddressForm existingAddresses={addresses} />}
      </QueryContainer>
    </RegisterLayout>
  );
};

export default Checkout;
